export default function About() {
  return (
    <section id="about" className="bg-background-50 sec">
      <div className="wrap">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-10 gap-x-8">
          <h2 data-reveal className="lg:col-span-6 font-heading font-light uppercase text-foreground-950 leading-[1] tracking-[0.02em] text-[38px] md:text-6xl lg:text-[76px]">A different<br />perspective.</h2>
          <div className="lg:col-span-5 lg:col-start-8 max-w-[480px] flex flex-col gap-5 text-[15px] leading-[1.65] text-foreground-700 lg:pt-3" data-reveal>
            <p className="text-lg md:text-xl font-light leading-snug text-foreground-950">An independent consultancy for executive teams at moments that matter.</p>
            <p>When direction needs to be set, an organization needs to change, or leaders need to move as one.</p>
            <p>We stay small on purpose. Senior advisors do the work themselves &mdash; advice that is direct and built to be carried out.</p>
          </div>
        </div>
        <div data-clip className="mt-16 md:mt-28 w-full aspect-[4/3] md:aspect-[21/9] overflow-hidden">
          <img src="https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_auren-about.webp" alt="Quiet modern workspace — AUREN strategy consultancy" title="AUREN management consulting workspace" className="w-full h-full object-cover object-center" />
        </div>
      </div>
    </section>
  );
}